import { render } from "./MouseCoordinate.vue?vue&type=template&id=236c56d8&scoped=true"
import script from "./MouseCoordinate.vue?vue&type=script&lang=js"
export * from "./MouseCoordinate.vue?vue&type=script&lang=js"

import "./MouseCoordinate.vue?vue&type=style&index=0&id=236c56d8&scoped=true&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c56d8"]])

export default __exports__